import { render } from "./TaskProgress.vue?vue&type=template&id=342fadf2&scoped=true"
import script from "./TaskProgress.vue?vue&type=script&lang=js"
export * from "./TaskProgress.vue?vue&type=script&lang=js"

import "./TaskProgress.vue?vue&type=style&index=0&id=342fadf2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342fadf2"]])

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress});
